import React,{ useEffect, useState } from "react";
import apiFetcher from "../../utils/apiFetcher";

const ConfirmationForm =({userData, service, city, address,startHour,endHour,link, selectedDate, setFormPage, referralCode,setDescription,amount}) => {
    const [price,setPrice] = useState(0);
    const rawToken = localStorage.getItem(`jwt`);
    const token = rawToken ? parseToken(rawToken) : null;
    const {name, surname, telephoneNumber, email} = token || userData
    const [error,setError] = useState(``)
    const [discountCode, setDiscountCode] = useState(``);
    const [block,setBlock] = useState(false);
    const [codeUsed, setCodeUsed] = useState(false);
    const calculatePoints = () => {
        const points = (endHour - startHour) * 10;
        return points
      
      }
    
    
      
    function parseToken(token) {
        return JSON.parse(atob(token.split('.')[1]));
    }
    async function getCode() {
        const data = await apiFetcher.getDiscountByCode(discountCode);
        if(!data) {
            setError(`Kod nieprawidłowy`);
            return
        }
        const {discountService, discount} = data
        console.log(service);
        console.log(discountService);
        console.log(discount)
        if(service.toLowerCase() !== discountService.toLowerCase()) {
            setError(`Ten kod jest na inną usługę.`)
            return
        }
        setPrice(price - discount);
        setCodeUsed(true)
    }

    const handleCodeClick = () => {
        if(codeUsed) {
            setError(`Nie możesz ponownie użyć kodu.`)
            return
        }
        if(discountCode.trim().length < 7) {
            setError(`Kod jest zbyt krótki.`)
            return
        }
        getCode()
    }


    const formatDate = (date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };


    const formatTime = (hour) => {
        return `${hour.toString().padStart(2, '0')}:00`;
    };

    const extractTimeData = (event) => {
    const start = new Date(event.start.dateTime);
    const end = new Date(event.end.dateTime);

    // 📅 tylko data (bez godziny)
    const suggestedDate = new Date(start);
    suggestedDate.setHours(0, 0, 0, 0);

    // 🕐 godziny w formacie HH:mm
    const formatTime = (date) =>
        date.toLocaleTimeString('pl-PL', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        });

    const timeWindow = {
        from: formatTime(start),
        to: formatTime(end),
    };

    return {
        suggestedDate,
        timeWindow,
    };
};


const extractCoordsFromGoogleLink = (url) => {
  try {
    const query = url.split('q=')[1];

    if (!query) return null;

    const [lat, lng] = query.split(',').map(Number);

    return { lat, lng };
  } catch (err) {
    console.log('Błąd parsowania linku:', err);
    return null;
  }
};


const createOrder = async (event) => {
  try {
    const { suggestedDate, timeWindow } = extractTimeData(event);

    const coords = extractCoordsFromGoogleLink(link);

    const order = {
      clientInfo: {
        name,
        surname,
        telephoneNumber,
        email,
      },

      type: "Dostawa materiału do klienta",
      service: `${service} ${amount}T`,

      location: {
        lat: coords?.lat,
        lng: coords?.lng
      },

      city: city.replace(/\([^)]*\)/, ''),
      address,
      price,
      description: `Zamówienie z formularza`,

      suggestedDate,
      timeWindow,
    };


    // 🔥 WYŚLIJ DO API
    const response = await apiFetcher.createOrder(order);

    return response;

  } catch (error) {
    console.log('createOrder error:', error);
    throw error;
  }
};

    const createEvent = ( userId = `Brak`) => {
        const newStartTime = selectedDate.setHours(startHour, 0, 0, 0);
        const newEndTime = selectedDate.setHours(endHour, 0, 0, 0)
        const description = `
        Imię i nazwisko klienta: ${name} ${surname}
        Numer telefonu: ${telephoneNumber}
        ${email? `E-mail: ${email}` : `E-mail: Nie podano` }
        Miejsowość: ${city.replace(/\([^)]*\)/,``)}
        Usługa: ${service} ${amount}
        Współrzędne: ${link}
        Cena: ${price}
    `
        setDescription(description);
        const event = {
            summary: service,
            description: description,
            start: {
                dateTime: new Date(newStartTime).toISOString(),
                timeZone: 'Europe/Warsaw'
            },
            end: {
                dateTime: new Date(newEndTime).toISOString(),
                timeZone: 'Europe/Warsaw'
            },
            location: city,
            extendedProperties: {
                private: {
                    userId: userId,
                }
            }
        };
        return event;
    }
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    const handleSubmit = async () => {
        if(block) return;
        setBlock(true)
        let event;
        let userId;
        if(token) {
            userId = token.id
            // const points = calculatePoints()
            // const addedPoints = await apiFetcher.addAwaitingPoints(userId,points);
        }
        event = createEvent(userId)

        const addEventToCalendar = await apiFetcher.addEventToGoogleCalendar(event)
        const addOrderToApp = await createOrder(event);
        if(addEventToCalendar) {
            if(referralCode) {
                const response = await apiFetcher.AddPointsByRefCode(referralCode,token);

            };
            if(codeUsed) {
                await apiFetcher.deleteCode(discountCode);
            }
            setFormPage(4);
        }
        setBlock(false);
        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    }

    useEffect(() => {
        async function getPrice() {
            const {price} = await apiFetcher.getPrice(city, service);
            console.log(price)
            console.log(amount)
            setPrice(price * (amount / 20));
        };


        getPrice();
    },[city, service]);


    return (
        <div className="confirm-form">
            <h4>Imię: {name}</h4>
            <h4>Nazwisko: {surname}</h4>
            <h4>Numer telefonu: {telephoneNumber} </h4>
            <h4>E-mail: {email || `Nie dotyczy`}</h4>
            <h4>Miejscowość: {city.replace(/\([^)]*\)/,``)}</h4>
            <h4>Usługa: {`${service} ${amount}T`}</h4>
            <h4>Data: {formatDate(selectedDate)}</h4>
            <h4>Godzina: {formatTime(startHour)} - {formatTime(endHour)}</h4>
            <h3>Cena: {price} zł</h3>

            {/* <div className="discount-code-container">
                <input onKeyDown={(e) => e.key === 'Enter' && handleCodeClick} max={10} placeholder="Kod zniżkowy (jeśli posiadasz)" value={discountCode} onChange={(e) => {setDiscountCode(e.target.value)}} ></input>
                <button onClick={handleCodeClick}><b>Użyj kodu</b></button>
            </div> */}
            <button disabled={block} onClick={() => handleSubmit()} id="confirm-button"><h3>Potwierdź &rarr;</h3> </button>
            {/* <span className="code-info">*Kod zniżkowy może być użyty tylko raz</span>
            <p>{error}</p> */}
        </div>
    )
}


export default ConfirmationForm;